import { colors, } from "common/styles/configLayout";

export const snackbarStyles = theme => ({
    success: { backgroundColor: colors.successAlpha, color: colors.successHover },
    error: { backgroundColor: colors.errorAlpha, color: colors.errorHover },
    warning: { backgroundColor: colors.warningAlpha, color: colors.warningHover },
    info: { backgroundColor: colors.primaryAlpha, color: colors.primaryHover },
});